import React, { useEffect, useRef, useState } from 'react';
import { ScrollTrigger } from '../gsap';
import '../styles/film.scss';
import CategoryIndicator from '../components/CategoryIndicator';
import videoD from '../assets/filmD.mp4';
import videoM from '../assets/filmM.mp4';
import Player from '@vimeo/player';
import close from '../assets/close.svg';

const Film = ({ screenWidth }) => {
  const videoloopRef = useRef();
  const filmRef = useRef();
  const vimeoRef = useRef();
  const videoModalRef = useRef();
  const closeRef = useRef();
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    ScrollTrigger.create({
      trigger: filmRef.current,
      start: 'top center',
      onEnter: () => {
        videoloopRef.current.play();
      }
    });
  }, []);
  useEffect(() => {
    vimeoRef.current = new Player('video2', {
      id: 763978530,
      controls: true,
      frameborder: '0',
      allow: 'fullscreen; picture-in-picture',
      responsive: true
    });
  }, []);

  useEffect(() => {
    if (showVideo) {
      videoModalRef.current.style.visibility = 'visible';
      closeRef.current.style.visibility = 'visible';
      vimeoRef.current.play();
    } else {
      videoModalRef.current.style.visibility = 'hidden';
      vimeoRef.current.pause();
      closeRef.current.style.visibility = 'hidden';
    }
  }, [showVideo]);

  useEffect(() => {
    vimeoRef.current.on('ended', () => {
      setShowVideo(false);
    });
  }, [setShowVideo]);

  return (
    <div className="film" id="film" ref={filmRef}>
      <div className="film__videoLoop">
        <video
          muted
          playsInline
          loop
          preload="auto"
          ref={videoloopRef}
          className="film__videoLoop-video"
        >
          {screenWidth > 720 ? (
            <source src={videoD} type="video/mp4" />
          ) : (
            <source src={videoM} type="video/mp4" />
          )}
        </video>
      </div>
      <div className="film__textCont">
        <CategoryIndicator origin="film" />
        <h4 className="bold">
          The Access I:
          <br />A Spacesuit for
          <br />
          Humankind
        </h4>
        <p className="small">
          Explore a future where everyone can participate in space. Join space engineer Vinita
          Marwaha Madill and former astronaut Cady Coleman as they work with a group of young
          scientists to test the Access I.
        </p>

        <button
          id="watchNow"
          onClick={() => {
            setShowVideo(true);
          }}
        >
          Watch Now
        </button>
      </div>
      <img
        className="film__close"
        src={close}
        alt="close video"
        ref={closeRef}
        onClick={() => {
          setShowVideo(false);
        }}
      />
      <div className="film__videoModal" ref={videoModalRef}>
        <div
          className="film__videoModal__vimeo"
          data-vimeo-id="763978530"
          id="video2"
          ref={vimeoRef}
        />
      </div>
    </div>
  );
};

export default Film;
